/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Style_Guide_Id_Required_ErrorInputs */



/**
* | output |
* | --- |
* | "Style guide ID is required" |
*
* @param {Iframe_Remote_Style_Guide_Id_Required_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_style_guide_id_required_error = /** @type {((inputs?: Iframe_Remote_Style_Guide_Id_Required_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Style_Guide_Id_Required_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID du guide de style requis")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Styleguide-ID ist erforderlich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("È richiesto l'ID della guida di stile")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Требуется идентификатор руководства по стилю.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se requiere identificación de la guía de estilo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("样式指南 ID 为必填项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スタイルガイドIDが必要です")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्टाइल गाइड आईडी आवश्यक है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("É necessário o ID do guia de estilo.")
	return /** @type {LocalizedString} */ ("Style guide ID is required")
});